import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoadingController } from 'ionic-angular';

/*
  Generated class for the LoadingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoadingProvider {
  public loading: any;
  constructor(public http: HttpClient, public loadingCtrl: LoadingController) {
    //console.log('Hello LoadingProvider Provider');
  }
  startLoading(){
    if(!this.loading){
        this.loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });
          this.loading.present()
    }
 
  }
  stopLoading(){
    setTimeout(() => {
      if(this.loading){
        this.loading.dismiss();
        this.loading = null;
      }
      
    }, 100);
  }

}



// WEBPACK FOOTER //
// ./src/providers/loading/loading.ts